var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetailer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5V13C2 13.1326 2.05268 13.2598 2.14645 13.3536C2.24021 13.4473 2.36739 13.5 2.5 13.5H12.5C12.6326 13.5 12.7598 13.4473 12.8536 13.3536C12.9473 13.2598 13 13.1326 13 13V8.5",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5V13.5",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11H8.5",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 4L2.5 0.5H12.5L14 4H1Z",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 4V5C5.25 5.53043 5.03929 6.03914 4.66421 6.41421C4.28914 6.78929 3.78043 7 3.25 7H2.97C2.43957 7 1.93086 6.78929 1.55579 6.41421C1.18071 6.03914 0.970001 5.53043 0.970001 5V4",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 4V5C9.75 5.53043 9.53929 6.03914 9.16421 6.41421C8.78914 6.78929 8.28043 7 7.75 7H7.25C6.71957 7 6.21086 6.78929 5.83579 6.41421C5.46071 6.03914 5.25 5.53043 5.25 5V4",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4V5C14 5.53043 13.7893 6.03914 13.4142 6.41421C13.0391 6.78929 12.5304 7 12 7H11.75C11.2196 7 10.7109 6.78929 10.3358 6.41421C9.96071 6.03914 9.75 5.53043 9.75 5V4",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailer);
export default __webpack_public_path__ + "static/media/retailer.eaaf975caca35c3fe296fe33be40202b.svg";
export { ForwardRef as ReactComponent };